var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02846 19.5334L2.02834 2.34154H8.34437L10.5444 4.54153H21.9932L21.9933 19.5334H2.02846ZM22.8213 2.6668H11.4556L9.25562 0.466797H1.1C0.492492 0.466797 0 0.959289 0 1.5668L0.000121325 20.2856C0.000121325 20.8931 0.492613 21.3856 1.10012 21.3856H22.8214C23.429 21.3856 23.9214 20.8931 23.9214 20.2856L23.9213 3.7668C23.9213 3.15929 23.4288 2.6668 22.8213 2.6668Z",
    fill: "#787E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58439 15.901V7.99415L16.5029 11.9476L9.58439 15.901Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.827dab6321ea0132bf0cf45bccab342d.svg";
export { ForwardRef as ReactComponent };